module.exports = __webpack_public_path__ + "static/media/suit-6.ba2bff5e.jpg";